"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var edit_roadmap_html_1 = __importDefault(require("./edit-roadmap.html"));
var edit_roadmap_controller_1 = __importDefault(require("./edit-roadmap.controller"));
var roadmap_resolves_1 = require("../roadmap-resolves");
function getRoadmap(RoadmapsModel, $stateParams) {
    return RoadmapsModel.show($stateParams.roadmapID).then(function (response) {
        return response.roadmap;
    });
}
getRoadmap.$inject = ["RoadmapsModel", "$stateParams"];
function config($stateProvider, $urlRouterProvider) {
    $stateProvider.state("drivecoach.admin.roadmaps.edit", {
        url: "/:roadmapID/edit-roadmap",
        controller: "EditRoadmapController",
        controllerAs: "vm",
        template: edit_roadmap_html_1.default,
        resolve: {
            roadmap: getRoadmap,
            sessionTypes: roadmap_resolves_1.getSessionTypes,
            instructors: roadmap_resolves_1.getInstructors,
            reportcardTypes: roadmap_resolves_1.getReportcardTypes,
            documentTemplates: roadmap_resolves_1.getDocumentTemplates,
            tasks: roadmap_resolves_1.getSchoolTasks,
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];
exports.default = angular_1.default
    .module("drivecoach.admin.roadmaps.edit", [])
    .config(config)
    .controller("EditRoadmapController", edit_roadmap_controller_1.default);
